import * as coreApi from "api/Core";
import ButtonClose from "components/Buttons/ButtonClose";
import { SpinnerIndicator } from 'components/CallServer';
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { GetUserProfileDto, UserProfileRelationDto } from 'models/ApiModels';
import * as React from 'react';
import UserProfileCardHeader from 'views/User/Components/UserProfileCardHeader';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    profile: GetUserProfileDto;
    lastError: any;
}

interface IProps {
    userId: string;
    onLoadComplete?: () => void;
    onClose?: () => void;
}

type Props = IProps & WithSnackbar;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserShortProfile extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            lastError: null,
            profile: null,
        };
    }

    ///
    private loadUser(userId: string) {
        coreApi.getUserProfile(userId)
            .then((profile) => {
                this.setState({ profile }, () => this.props.onLoadComplete && this.props.onLoadComplete());
            })
            .catch((error) => {
                this.setState({ lastError: error });
            });
    }

    ///
    private handleRelationChange = (newRelation: UserProfileRelationDto) => {
        this.setState(current => {
            current.profile.currentUserRelation = newRelation;
            return current;
        });
    };

    ///
    public componentDidMount() {
        this.loadUser(this.props.userId);
    }

    ///
    public render() {
        const { lastError, profile } = this.state;

        return (
            <div>
                {
                    lastError
                        ? (
                            <RequestErrorReport
                                error={lastError}
                                action={<ButtonClose onClick={() => this.props.onClose()} />}
                            />
                        )
                        : profile == null
                            ? (
                                <div style={{ height: 100, width: 100, display: "flex", justifyContent: "center", alignItems: "center", border: "solid 1px #000" }}>
                                    <div><SpinnerIndicator /></div>
                                </div>
                            )
                            : (
                                <UserProfileCardHeader
                                    profile={profile}
                                    showFullProfileButton={true}
                                    onClose={this.props.onClose}
                                    onRelationChange={this.handleRelationChange}
                                    onQuestionCreated={() => { if (this.props.onClose) this.props.onClose(); }}
                                />
                            )
                }
            </div>
        );
    }
}

export default withSnackbar(UserShortProfile);